<template>
  <div>
    <div v-if="loading">
      <div class="text-center pt-9 mt-9">
        <Loading></Loading>
      </div>
    </div>
    <div style="padding-bottom: 35px" v-else>
      <div style="text-align: center; position: relative" class="py-2 mb-3">
        <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
        <div style="position: absolute; right: 15px; top: 15px">
          <v-chip
            class="px-3 py-1"
            @click="onClickSearch"
            :close="search ? true : false"
            small
            color="#0A4EA2"
            text-color="white"
            @click:close="clearSearch"
            >{{ search ? search : "ค้นหาสีด้วยรหัส" }}</v-chip
          >
        </div>
      </div>
      <v-container class="Kanit px-5" grid-list-xs>
        <div class="text-center">
          <h2 class="mb-3" style="color: #0a4ea2">กรุณาเลือกสีที่ต้องการ</h2>
        </div>
        <div
          style="
            font-size: 12px;
            color: darkred;
            margin-top: 13px;
            margin-bottom: 15px;
          "
        >
          หมายเหตุ :
          สีที่ได้อาจมีความผิดเพี้ยนเล็กน้อยจากสีจริงตามความแตกต่างของหน้าจอแสดงผล
        </div>
        <template v-if="filteredData && filteredData.length">
          <v-row v-click-outside="clickoutside">
            <template v-for="(item, k) in filteredData">
              <v-col
                v-if="
                  (item.rgb != 'colorworld' && !item.colorworld) || searchdata
                "
                class="pa-1"
                cols="3"
                :key="k"
              >
                <div style="height: 100%" @click="chooseColor(item, k)">
                  <v-card
                    :elevation="active === k ? 8 : 0"
                    :class="{ colorcard: true, active: active === k }"
                    style="border-radius: 10px; height: 100%"
                  >
                    <div
                      v-if="item.rgb"
                      class="pa-2"
                      :style="`background-color: rgb(${item.rgb}); height: 70px`"
                    >
                      <div
                        class="Kanit px-2 textswap"
                        :style="'display: table-cell;color:darkgrey;border-radius: 15px; background-color: white;font-weight: 600;'"
                      >
                        {{ item.shade }}
                      </div>
                    </div>
                    <div
                      v-else-if="item.color"
                      class="pa-2"
                      :style="`height: 100%`"
                    >
                      <v-img
                        class="fill-height"
                        lazy-src="../assets/whiteimg.jpg"
                        :src="item.color"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>
                    <div v-else :style="`height: 70px`">
                      <div
                        class="Kanit px-2 textswap"
                        :style="'display: table-cell;color:darkgrey;border-radius: 15px; background-color: white;font-weight: 600;'"
                      >
                        {{ item.shade }}
                      </div>
                    </div>
                  </v-card>
                </div>
              </v-col>
            </template>
          </v-row>
        </template>
        <template v-else>
          <div class="text-center" style="font-size: 20px">ไม่พบข้อมูล</div>
        </template>

        <div class="px-4" style="margin-top: 15px">
          <v-btn
            v-if="isColorWorld"
            block
            @click="
              selectedColor = '';
              active = '';
              showColorWorld = true;
            "
            color="#0A4EA2"
            style="color: white; border-radius: 13px; font-size: 16px"
            >เลือกสีเพิ่มเติม</v-btn
          >
        </div>
      </v-container>
      <transition name="slide">
        <div
          style="z-index: 3"
          v-if="
            (selectedColor || selectedShade) && selectedColor != 'colorworld'
          "
          :key="selectedColor"
          class="proceedbtn"
        >
          <!-- {{ rgbToHex(selectedColor) }} -->
          <div
            v-if="
              (!selectedColor && selectedShade) ||
              !selectedColor.includes('https://')
            "
            v-ripple
            tile
            :style="`height: 62px;font-size: 30px;background-color: ${
              selectedColor ? 'rgb(' + selectedColor + ')' : ''
            }`"
            :disabled="!selectedColor"
            class="Kanit proceedbtn myshadow"
            block
            @click="confirmColor(false)"
          >
            <div v-if="saveloading">
              <div
                :style="`margin-top: 5px;font-size: 28px;color:${
                  $options.filters.setContrast(selectedColor).text
                };`"
              >
                <v-progress-circular
                  indeterminate
                  size="40"
                ></v-progress-circular>
              </div>
            </div>
            <div
              v-else
              :style="`
                margin-top: 5px;
                color: darkgrey;
                font-size: 23px;
                background-color: white;
                display: inline-block;
                border-radius: 13px;`"
              class="px-4"
            >
              ยืนยัน
            </div>
          </div>
          <div
            v-else
            v-ripple
            @click.stop="confirmColor(false)"
            tile
            :style="`height: 60px;font-size: 30px;background-color: rgb(12, 77, 157)`"
            :disabled="!selectedColor || saveloading"
            class="Kanit proceedbtn myshadow"
            block
          >
            <div v-if="saveloading">
              <div style="margin-top: 5px; font-size: 28px; color: white">
                <v-progress-circular
                  indeterminate
                  size="40"
                ></v-progress-circular>
              </div>
            </div>
            <div
              v-else
              :style="`margin-top: 5px;color: ${
                $options.filters.setContrast(selectedColor).text
              }`"
              :class="'textbtn'"
            >
              ยืนยัน
            </div>
          </div>
        </div>
      </transition>
      <v-dialog fullscreen v-model="showColorWorld">
        <v-card v-if="showColorWorld" tile>
          <color-world
            @confirmColor="confirmColorWorld"
            @closeColorWorld="showColorWorld = false"
          ></color-world>
        </v-card>
      </v-dialog>
      <v-dialog v-model="searchModal">
        <div class="px-4 Kanit lg3">
          <v-text-field
            @keyup.enter="onSearch"
            ref="searchinput"
            style="border-radius: 17px"
            placeholder="กรุณาใส่เฉดสีที่ต้องการ"
            outlined
            solo
            v-model="inputsearch"
          >
            <template v-slot:append>
              <v-btn @click="onSearch" :loading="searchloading" icon outlined>
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import ColorWorld from "./ColorWorld.vue";
import axios from "axios";
import Loading from "@/components/Loading.vue";

export default {
  components: {
    ColorWorld,
    Loading,
  },
  data() {
    return {
      isSelectedColorWorld: false,
      searchModal: false,
      searchloading: false,
      serverUrl: "https://communitybotbyzwizai.herokuapp.com/",
      loading: true,
      saveloading: false,
      selectedShade: "",
      showColorWorld: false,
      selectedColor: "",
      active: null,
      data: [],
      searchdata: null,
      search: "",
      inputsearch: "",
    };
  },
  computed: {
    filteredData() {
      if (this.searchdata) {
        var result = this.searchdata;
      } else {
        var result = this.data;
        result = result.filter((el) => {
          return el.rgb != "colorworld";
        });
      }
      result = result.sort((a, b) =>
        a.shade > b.shade ? 1 : a.shade < b.shade ? -1 : 0
      );
      return result;
    },
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    isColorWorld() {
      return this.data.filter((el) => {
        return el.rgb == "colorworld" || el.colorworld == true;
      }).length;
    },
  },
  async mounted() {
    // if(this.query.main_category == '')
    if (this.query.main_category == "Decorative Coatings") {
      this.showColorWorld = true;
    }
    await this.getColor();
  },
  methods: {
    onClickSearch() {
      var vm = this;
      this.searchModal = true;
      this.$nextTick(() => {
        setTimeout(function () {
          vm.$refs.searchinput.focus();
        }, 300);
      });
    },
    clearSearch() {
      this.search = "";
      this.searchdata = null;
      this.inputsearch = "";
    },
    onSearch() {
      var vm = this;
      vm.searchloading = true;
      vm.search = vm.inputsearch;
      axios
        .get(vm.serverUrl + "toasearchallcolors", {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
          params: {
            main_category: vm.query.main_category,
            category: vm.query.category,
            search: vm.inputsearch,
            group: vm.query.group,
            size: vm.query.size,
          },
        })
        .then(async (response) => {
          this.searchloading = false;
          if (response.data && response.data.responsecode == 400) {
            await this.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            return;
          } else if (response.data.responsecode == 200) {
            vm.searchdata = response.data.data;
            this.searchModal = false;
          } else {
            vm.searchdata = [];
            this.searchModal = false;
          }
          this.searchloading = false;
        });
      // this.search = this.inputsearch;
    },
    clickoutside() {
      this.active = "";
      this.selectedColor = "";
      this.selectedShade = "";
    },
    chooseColor(item, k) {
      this.active = k;
      if (item.rgb) {
        this.selectedColor = item.rgb;
      } else this.selectedColor = item.color;
      if (item.colorworld) {
        this.isSelectedColorWorld = true;
      } else this.isSelectedColorWorld = false;
      this.selectedShade = item.shade;
    },
    confirmColorWorld(payload) {
      this.selectedShade = payload.colorcode;
      this.selectedColor = payload.shade;
      this.confirmColor(true);
    },
    confirmColor(isColorWorld) {
      var vm = this;
      if (!this.saveloading) {
        this.saveloading = true;
        var color = this.selectedColor;
        var data = {
          userid: this.$store.state.userid,
          apptype: this.query.apptype,
          pageid: this.query.pageid,
          shade: this.selectedShade,
          main_category: this.query.main_category,
          category: this.query.category,
          color: color ? color : "",
          colorworld: isColorWorld ? true : false,
        };
        if (this.isSelectedColorWorld) {
          data.colorworld = true;
        }
        if (isColorWorld) {
          this.query.isColorWorld = "true";
        } else {
          this.query.isColorWorld = "false";
        }
        if (this.query.flowtype == "colorlast") {
          Object.assign(this.query, {
            shade: this.selectedShade,
            color: color,
            view: "Product",
          });
        } else {
          axios
            .post(this.serverUrl + "toachoosecolor", data, {
              headers: {
                AUTHORIZATION: "Bearer xx xx",
              },
            })
            .then(async (response) => {
              if (response.data && response.data.responsecode == 400) {
                await this.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                return;
              }
              if (response.data.responsecode == 200) {
                if (this.query.apptype == "line") {
                  await this.$liff.closeWindow();
                } else if (this.query.apptype == "facebook") {
                  this.$store.dispatch("messengerClose");
                }
              } else {
                this.$swal.fire({
                  icon: "error",
                  text: `Error code: ${response.data.responsecode}, ${response.data.reason}`,
                });
              }
              vm.saveloading = false;
            });
        }
      }
    },
    getColor() {
      return new Promise((resolve) => {
        var params, api;
        if (this.query.flowtype == "colorfirst") {
          params = {
            main_category: this.query.main_category,
            category: this.query.category,
            flowtype: this.query.flowtype,
          };
          api = "toachoosecolor";
        } else {
          params = {
            main_category: this.query.main_category,
            size: this.query.size,
            flowtype: this.query.flowtype,
            group: this.query.group,
            film_type: this.query.film_type,
          };
          api = "toargborshadecoatings";
        }
        axios
          .get(`https://communitybotbyzwizai.herokuapp.com/${api}`, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
            params,
          })
          .then(async (response) => {
            this.loading = false;
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              resolve();
            } else if (response.data.responsecode == 200) {
              this.data = response.data.data;
              if (!this.filteredData.length && this.isColorWorld) {
                this.showColorWorld = true;
              }
              resolve();
            }
            resolve();
          });
      });
    },
    rgbToHex(rgb) {
      if (rgb) {
        var myrgb = rgb.split(",");
      } else return "";
      return (
        "#" +
        (
          (1 << 24) +
          (parseInt(myrgb[0]) << 16) +
          (parseInt(myrgb[1]) << 8) +
          parseInt(myrgb[2])
        )
          .toString(16)
          .slice(1)
      );
    },
  },
  filters: {
    setContrast(myrgb) {
      var rgb = myrgb.split(",");

      // Randomly update colours
      const brightness = Math.round(
        (parseInt(rgb[0]) * 299 +
          parseInt(rgb[1]) * 587 +
          parseInt(rgb[2]) * 114) /
          1000
      );
      const textColour = brightness > 145 ? "black" : "white";
      const backgroundColour =
        "rgb(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + ")";
      return { text: textColour, background: backgroundColour };
    },
  },
};
</script>

<style lang="scss">
.textswap {
  /* This value is the OPPOSITE color of our background */
  // color: transparent;
  // filter: invert(1) grayscale(100%);
  font-size: 10px;
  font-weight: 500;
  text-align: center;
}
.colorcard {
  transition: all 0.2s ease-in-out;
}
.active {
  transform: scale(1.1);
  z-index: 2;
}
.proceedbtn {
  left: 50%;
  transform: translate(-50%, 0);
  position: fixed;
  bottom: 0px;
  border-radius: 10px 10px 0px 0px;
  text-align: center;
  width: 90%;
}
.textbtn {
  background: inherit;
  background-clip: text;
}
.slide-enter-active {
  transition: all 0.25s ease;
}
.slide-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-enter, .slide-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(70px);
  opacity: 50;
}
.myshadow {
  -webkit-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  -moz-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 3px 23px -1px rgba(0, 0, 0, 0.25);
}
.v-dialog {
  box-shadow: none !important;
}
</style>